title: Instellingen
tabHeadings:
  user: Medewerkers
  treatment: Behandelingen
  companyDetails: Algemene info
  payment: Abonnement
messages:
  subtitle: Beheer medewerkers, behandelingen en algemene info
